<template>
  <el-tree :data="chapters" :props="props" @node-click="onClick" node-key="id" highlight-current accordion />
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
const props = { children: 'children', label: 'label' }
const chapters = ref([])

const data = [
  {
    label: 'Level one 1',
    children: [
      {
        label: 'Level two 1-1',
        children: [
          {
            label: 'Level three 1-1-1',
          },
        ],
      },
    ],
  },
  {
    label: 'Level one 2',
    children: [
      {
        label: 'Level two 2-1',
        children: [
          {
            label: 'Level three 2-1-1',
          },
        ],
      },
      {
        label: 'Level two 2-2',
        children: [
          {
            label: 'Level three 2-2-1',
          },
        ],
      },
    ],
  },
  {
    label: 'Level one 3',
    children: [
      {
        label: 'Level two 3-1',
        children: [
          {
            label: 'Level three 3-1-1',
          },
        ],
      },
      {
        label: 'Level two 3-2',
        children: [
          {
            label: 'Level three 3-2-1',
          },
        ],
      },
    ],
  },
]

const emit = defineEmits(['select-chapter'])

onMounted(async () => {
  const res = await axios.get('/api/chapters')
  // chapters.value = res.data
  chapters.value = data
})

const onClick = (node) => {
  emit('select-chapter', node.id)
}
</script>

<style scoped>
.el-tree {
  border-right: 1px solid #e0e0e0;
  padding: 16px;
}
</style>
